import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  style: {"position":"absolute","margin-left":"50px","margin-top":"-10px"},
  width: "24",
  height: "24",
  src: "/ico/edit-picture.svg"
}, null, -1)
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pickIllustration && _ctx.pickIllustration(...args))),
    class: "img-container"
  }, [
    _hoisted_1,
    _createElementVNode("img", {
      style: {"object-fit":"cover","width":"100%","height":"100%","border-radius":"6px"},
      ref: "picture",
      src: _ctx.src
    }, null, 8, _hoisted_2)
  ]))
}